export const EDIT_SHOPPING_AREA = "EDIT_SHOPPING_AREA"
export const EDIT_SHOPPING_AREA_SUCCESS = "EDIT_SHOPPING_AREA_SUCCESS"
export const EDIT_SHOPPING_AREA_CLEAN = "EDIT_USER_CLEAN"
export const EDIT_SHOPPING_AREA_ERROR = "EDIT_SHOPPING_AREA_ERROR"
